import React from 'react';
import ModalHOC from '../../hoc/Modal/ModalHOC';
import RatesTablesSelection from '../Customer/RatesTablesSelection';
import {useIntl} from "react-intl";

let ModalCreateRate = (props) => {
    const intl = useIntl();

    return (
        <div id="modal" className="modal">
            <div className="modal-background" onClick={props.closeModal }></div>
            <div className="modal-card">
                <header className="modal-card-head">
                    <p className="modal-card-title">{props.title}</p>
                    <button className="delete" aria-label="close" onClick={ props.closeModal }></button>
                </header>

                <section className="modal-card-body">
                    <RatesTablesSelection customer_id={props.extraData.customer_id}/>
                </section>

                <footer className="modal-card-foot">
                    <button className="button is-info" aria-label="close" onClick={ props.closeModal }>{intl.formatMessage({id: "general.accept"})}</button>
                </footer>
            </div>
        </div>
    );
}

export default ModalHOC(ModalCreateRate);
